import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { MailCheck, ShieldAlert } from "lucide-react";
import { api, fmtErr } from "../lib/api";

export default function ConfermaEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ loading: true, ok: false, message: "" });

  useEffect(() => {
    const token = params.get("token") || "";
    if (!token) {
      setState({ loading: false, ok: false, message: "Questo link non è valido." });
      return;
    }
    api.post("/profile/email/confirm", { token })
      .then((r) => setState({ loading: false, ok: true, message: r.data.message }))
      .catch((e) => setState({ loading: false, ok: false, message: fmtErr(e) }));
  }, [params]);

  return (
    <div className="max-w-md mx-auto px-4 py-20 text-center" data-testid="conferma-email-page">
      {state.loading ? (
        <div className="font-cinzel text-amber-400 tracking-[0.3em] text-sm animate-pulse">ARCANA</div>
      ) : (
        <>
          {state.ok ? (
            <MailCheck className="w-12 h-12 text-emerald-300 mx-auto" />
          ) : (
            <ShieldAlert className="w-12 h-12 text-rose-300 mx-auto" />
          )}
          <h1 className="font-display text-3xl text-amber-100 mt-6">
            {state.ok ? "Email aggiornata" : "Cambio non riuscito"}
          </h1>
          <p className="text-purple-100/80 text-sm leading-relaxed mt-4 max-w-sm mx-auto" data-testid="conferma-email-message">
            {state.message}
          </p>
          <Link
            to={state.ok ? "/accedi" : "/cliente"}
            data-testid="conferma-email-cta"
            className="gold-btn inline-block mt-8 px-8 py-3 text-sm"
          >
            {state.ok ? "Accedi con la nuova email" : "Vai all'Area Cliente"}
          </Link>
        </>
      )}
    </div>
  );
}
